import React from 'react';

const PageIndicator = ({ currentPage, totalPages, pageTitle }) => {
  // Format page numbers with leading zeros
  const formatPageNumber = (num) => {
    return num.toString().padStart(2, '0');
  };

  return (
    <footer className="py-6 px-4">
      <div className="flex flex-col items-center gap-2">
        {/* Page Title */}
        {pageTitle && (
          <div className="text-base font-medium tracking-wide text-muted-foreground">
            {pageTitle}
          </div>
        )}
        
        <div className="flex justify-center items-center gap-3">
          {/* Page dots indicator */}
          <div className="flex items-center gap-2">
            {Array.from({ length: totalPages }, (_, index) => (
              <div 
                key={index}
                className={`h-2 rounded-full transition-all duration-300 ${
                  index + 1 === currentPage 
                    ? 'w-8 bg-accent' 
                    : 'w-2 bg-muted-foreground/30'
                }`}
              />
            ))}
          </div>
          
          {/* Text indicator */}
          <div className="ml-4 text-base font-medium tracking-wide text-muted-foreground">
            Page <span className="text-foreground font-semibold">{formatPageNumber(currentPage)}</span> of <span className="text-foreground font-semibold">{formatPageNumber(totalPages)}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export { PageIndicator };
export default PageIndicator;
